/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

import Footer from "../common/Footer";
import DashboardHeader from "../common/DashboardHeader";
import DashBoard from "../Dashboard";
import AdminDashboard from "../AdminDashboard";
import useUserStore from "../../stores/useUserStores";

const AuthAdminDashboard = (props: any) => {
  const { userdetail, setuserdetail, islogin, setislogin, isAdmin } =
    useUserStore();

  const navigate = useNavigate();

  const location = useLocation();

  useEffect(() => {
    if (!islogin) {
      navigate("/", {
        replace: true,
      });
    } else if (
      location.pathname === "/admin-dashboard" &&
      userdetail.userType !== "TCADMIN"
    ) {
      navigate("/admin-dashboard/create-list", {
        replace: true,
      });
    }
  }, []);
  const [side, setside] = useState(false);

  const handleside = () => {
    setside(!side);
  };

  return (
    <>
      {islogin && isAdmin ? (
        <>
          <DashboardHeader side={side} handleside={handleside} />
          <AdminDashboard side={side} handleside={handleside} />
          {/* <Footer /> */}
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default AuthAdminDashboard;
